module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8mBqt"))).then(() => parcelRequire('2KbAe'));